export { SEO, default } from './SEO';
export type { SEOProps } from './SEO';

// SEO utility functions
export const generatePageTitle = (pageTitle: string, siteName = 'My EZTopup') => {
  return `${pageTitle} | ${siteName}`;
};

export const generateMetaDescription = (content: string, maxLength = 160) => {
  return content.length > maxLength ? content.substring(0, maxLength - 3) + '...' : content;
};

export const generateKeywords = (baseKeywords: string[], pageKeywords: string[] = []) => {
  return [...baseKeywords, ...pageKeywords].join(', ');
};

// Common SEO constants
export const BASE_KEYWORDS = [
  'mobile topup',
  'data packages',
  'e-gift cards',
  'Myanmar',
  'digital recharge',
  'phone credit',
  'instant topup',
  'MPT',
  'Ooredoo',
  'Telenor',
  'Atom',
  'MyTel',
];

export const SITE_CONFIG = {
  siteName: 'My EZTopup',
  siteUrl: 'https://myeztopup.com/',
  defaultImage: '/logo.svg',
  twitterHandle: '@myeztopup',
  locale: 'en_US',
  alternateLocale: 'my_MM',
};
